module.exports = {
    "collectionLabel": `Sugerencias`
};


//# sourceMappingURL=es-ES.main.js.map
